export const isReactNative = (): boolean => !!process.env.JS_ENV_NATIVE;
